import { render, staticRenderFns } from "./privacy-policies.vue?vue&type=template&id=5c53b308&scoped=true"
import script from "./privacy-policies.vue?vue&type=script&lang=js"
export * from "./privacy-policies.vue?vue&type=script&lang=js"
import style0 from "./privacy-policies.vue?vue&type=style&index=0&id=5c53b308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53b308",
  null
  
)

export default component.exports